<div role="dialog" aria-modal="true" aria-labelledby="modal-title-commit-plan">
<div class="modal-header">
  <h4 id="modal-title-commit-plan" class="modal-title">Commit Plan</h4>
</div>

<div class="modal-body">
  <p [innerHtml]="warningMessage"></p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-warning" (click)="close()">Close</button>
</div>
</div>
